import { Avatar, Box, useTheme } from '@mui/material';
import React, { forwardRef } from 'react';

import level0Frame from 'assets/rewards/frames/Level=0.svg';
import level1Frame from 'assets/rewards/frames/Level=1.svg';
import level2Frame from 'assets/rewards/frames/Level=2.svg';
import level3Frame from 'assets/rewards/frames/Level=3.svg';
import level4Frame from 'assets/rewards/frames/Level=4.svg';
import level5Frame from 'assets/rewards/frames/Level=5.svg';
import level6Frame from 'assets/rewards/frames/Level=6.svg';

// MAvatar.propTypes = {
//   children: PropTypes.node,
//   sx: PropTypes.object,
//   color: PropTypes.oneOf(['default', 'primary', 'secondary', 'info', 'success', 'warning', 'error'])
// };

// TODO: Add typings
// @ts-ignore
// eslint-disable-next-line react/display-name
const MAvatar = forwardRef(({ color = 'default', sx, children, level, ...other }, ref) => {
    const theme = useTheme();

    if (color === 'default') {
        return (
            // @ts-ignore
            <Avatar ref={ref} sx={sx} {...other}>
                {children}
            </Avatar>
        );
    }

    const levelToFrame = {
        0: level0Frame,
        1: level1Frame,
        2: level2Frame,
        3: level3Frame,
        4: level4Frame,
        5: level5Frame,
        6: level6Frame,
    };

    return typeof level === 'number' ? (
        <Box
            sx={{
                position: 'relative',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                px: 1,
            }}
        >
            <img
                src={levelToFrame[level]}
                alt={`Frame`}
                style={{
                    position: 'absolute',
                    top: '-20%',
                    left: 0,
                    width: '100%',
                    height: '140%',
                    objectFit: 'cover',
                    zIndex: 1,
                }}
            />
            {/* @ts-ignore */}
            <Avatar
                ref={ref}
                sx={{
                    fontWeight: theme.typography.fontWeightMedium,
                    color: theme.palette[color].contrastText,
                    backgroundColor: theme.palette[color].main,
                    border: `solid 2px ${theme.palette.common.black}`,
                    position: 'relative',
                    zIndex: 0,
                    ...sx,
                }}
                {...other}
            >
                {children}
            </Avatar>
        </Box>
    ) : (
        // @ts-ignore
        <Avatar
            ref={ref}
            sx={{
                fontWeight: theme.typography.fontWeightMedium,
                color: theme.palette[color].contrastText,
                backgroundColor: theme.palette[color].main,
                border: `solid 2px ${theme.palette.common.black}`,
                ...sx,
            }}
            {...other}
        >
            {children}
        </Avatar>
    );
});

export default MAvatar;
